import { render, staticRenderFns } from "./MenuCardHorizontal.vue?vue&type=template&id=436a758c"
import script from "./MenuCardHorizontal.vue?vue&type=script&lang=ts"
export * from "./MenuCardHorizontal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports